import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FormFieldsProps {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  company?: string;
  isPro: boolean;
  onChange: (field: string, value: string) => void;
}

export const FormFields = ({
  firstName,
  lastName,
  email,
  phone,
  company,
  isPro,
  onChange,
}: FormFieldsProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName">Prénom</Label>
          <Input
            id="firstName"
            required
            value={firstName}
            onChange={(e) => onChange("firstName", e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Nom</Label>
          <Input
            id="lastName"
            required
            value={lastName}
            onChange={(e) => onChange("lastName", e.target.value)}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          required
          value={email}
          onChange={(e) => onChange("email", e.target.value)}
        />
      </div>

      {isPro && (
        <>
          <div className="space-y-2">
            <Label htmlFor="phone">Téléphone</Label>
            <Input
              id="phone"
              type="tel"
              value={phone}
              onChange={(e) => onChange("phone", e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="company">Entreprise</Label>
            <Input
              id="company"
              value={company}
              onChange={(e) => onChange("company", e.target.value)}
            />
          </div>
        </>
      )}
    </div>
  );
};